module.exports = __webpack_public_path__ + "static/3p-9edc3a3b798b2f0926339cbcd5e1ca62.jpg";